var ENDOFCHAIN = -2;
var FREESECT = -1;
var FATSECT = -3;
var DIFSECT = -4;
function readSector(ctx, sectorIndex) {
    var start = (sectorIndex + 1) * ctx.sectorSize;
    return ctx.bytes.subarray(start, start + ctx.sectorSize);
}
function readChain(ctx, startSector, streamSize) {
    var out = new Uint8Array(streamSize);
    var offset = 0;
    var sector = startSector;
    var guard = 0;
    while (sector !== ENDOFCHAIN && sector !== FREESECT && offset < streamSize && guard < 1000000) {
        var sectorBytes = readSector(ctx, sector);
        var remaining = streamSize - offset;
        out.set(sectorBytes.subarray(0, Math.min(sectorBytes.length, remaining)), offset);
        offset += sectorBytes.length;
        sector = ctx.fat[sector];
        guard += 1;
    }
    return out;
}
function readMiniChain(ctx, startSector, streamSize) {
    var out = new Uint8Array(streamSize);
    var offset = 0;
    var sector = startSector;
    var guard = 0;
    while (sector !== ENDOFCHAIN && sector !== FREESECT && offset < streamSize && guard < 1000000) {
        var start = sector * ctx.miniSectorSize;
        var chunk = ctx.miniStream.subarray(start, start + ctx.miniSectorSize);
        var remaining = streamSize - offset;
        out.set(chunk.subarray(0, Math.min(chunk.length, remaining)), offset);
        offset += chunk.length;
        sector = ctx.miniFat[sector];
        guard += 1;
    }
    return out;
}
function readStream(ctx, entry) {
    if (entry.streamSize < ctx.miniStreamCutoff) {
        return readMiniChain(ctx, entry.startSector, entry.streamSize);
    }
    return readChain(ctx, entry.startSector, entry.streamSize);
}
function parseCfb(buffer) {
    var view = new DataView(buffer);
    var bytes = new Uint8Array(buffer);
    if (view.getUint32(0, false) !== 0xd0cf11e0 || view.getUint32(4, false) !== 0xa1b11ae1) {
        throw new Error('Not a valid OLE/CFB (.doc) file.');
    }
    var sectorShift = view.getUint16(30, true);
    var miniSectorShift = view.getUint16(32, true);
    var sectorSize = 1 << sectorShift;
    var miniSectorSize = 1 << miniSectorShift;
    var sectDirStart = view.getInt32(48, true);
    var miniStreamCutoff = view.getUint32(56, true);
    var sectMiniFatStart = view.getInt32(60, true);
    var sectDifStart = view.getInt32(68, true);
    var csectDif = view.getUint32(72, true);
    var fatSectorNumbers = [];
    for (var i = 0; i < 109; i += 1) {
        var value = view.getInt32(76 + i * 4, true);
        if (value === FREESECT || value === -1)
            break;
        fatSectorNumbers.push(value);
    }
    var difSector = sectDifStart;
    var difGuard = 0;
    while (difSector !== ENDOFCHAIN && difSector !== FREESECT && difGuard < csectDif + 1 && difGuard < 10000) {
        var sectorStart = (difSector + 1) * sectorSize;
        var entriesPerSector = sectorSize / 4;
        for (var i = 0; i < entriesPerSector - 1; i += 1) {
            var value = view.getInt32(sectorStart + i * 4, true);
            if (value === FREESECT || value === -1)
                break;
            fatSectorNumbers.push(value);
        }
        difSector = view.getInt32(sectorStart + (entriesPerSector - 1) * 4, true);
        difGuard += 1;
    }
    var entriesPerFatSector = sectorSize / 4;
    var fat = [];
    fatSectorNumbers.forEach(function (fatSectorIndex) {
        var sectorStart = (fatSectorIndex + 1) * sectorSize;
        for (var i = 0; i < entriesPerFatSector; i += 1) {
            fat.push(view.getInt32(sectorStart + i * 4, true));
        }
    });
    var ctx = {
        view: view,
        bytes: bytes,
        sectorSize: sectorSize,
        miniSectorSize: miniSectorSize,
        miniStreamCutoff: miniStreamCutoff,
        fat: fat,
        miniFat: [],
        miniStream: new Uint8Array(0),
        entries: [],
    };
    var dirSectors = [];
    var dirSector = sectDirStart;
    var dirGuard = 0;
    while (dirSector !== ENDOFCHAIN && dirSector !== FREESECT && dirGuard < 1000000) {
        dirSectors.push(readSector(ctx, dirSector));
        dirSector = fat[dirSector];
        dirGuard += 1;
    }
    var dirBytes = new Uint8Array(dirSectors.reduce(function (sum, s) { return sum + s.length; }, 0));
    var dirOffset = 0;
    dirSectors.forEach(function (s) { dirBytes.set(s, dirOffset); dirOffset += s.length; });
    var dirView = new DataView(dirBytes.buffer, dirBytes.byteOffset, dirBytes.byteLength);
    var entries = [];
    var rootStartSector = -1;
    var rootStreamSize = 0;
    for (var entryOffset = 0; entryOffset + 128 <= dirBytes.length; entryOffset += 128) {
        var objectType = dirView.getUint8(entryOffset + 66);
        if (objectType === 0)
            continue;
        var nameLenBytes = dirView.getUint16(entryOffset + 64, true);
        var nameCharCount = Math.max(0, Math.floor(nameLenBytes / 2) - 1);
        var name_1 = '';
        for (var c = 0; c < nameCharCount; c += 1) {
            name_1 += String.fromCharCode(dirView.getUint16(entryOffset + c * 2, true));
        }
        var startSector = dirView.getInt32(entryOffset + 116, true);
        var streamSize = dirView.getUint32(entryOffset + 120, true);
        if (objectType === 5) {
            rootStartSector = startSector;
            rootStreamSize = streamSize;
        }
        entries.push({ name: name_1, type: objectType, startSector: startSector, streamSize: streamSize });
    }
    if (rootStartSector >= 0) {
        ctx.miniStream = readChain(ctx, rootStartSector, rootStreamSize);
    }
    if (sectMiniFatStart !== ENDOFCHAIN && sectMiniFatStart !== FREESECT) {
        var miniFatSectors = [];
        var miniFatSector = sectMiniFatStart;
        var miniFatGuard = 0;
        while (miniFatSector !== ENDOFCHAIN && miniFatSector !== FREESECT && miniFatGuard < 1000000) {
            miniFatSectors.push(readSector(ctx, miniFatSector));
            miniFatSector = fat[miniFatSector];
            miniFatGuard += 1;
        }
        var miniFatBytes_1 = new Uint8Array(miniFatSectors.reduce(function (sum, s) { return sum + s.length; }, 0));
        var miniFatOffset_1 = 0;
        miniFatSectors.forEach(function (s) { miniFatBytes_1.set(s, miniFatOffset_1); miniFatOffset_1 += s.length; });
        var miniFatView = new DataView(miniFatBytes_1.buffer, miniFatBytes_1.byteOffset, miniFatBytes_1.byteLength);
        for (var i = 0; i + 4 <= miniFatBytes_1.length; i += 4) {
            ctx.miniFat.push(miniFatView.getInt32(i, true));
        }
    }
    ctx.entries = entries;
    return ctx;
}
function findEntry(entries, name) {
    return entries.find(function (entry) { return entry.name === name; });
}
function decodeAnsi(bytes) {
    try {
        return new TextDecoder('windows-1252').decode(bytes);
    }
    catch (_a) {
        return Array.from(bytes).map(function (b) { return String.fromCharCode(b); }).join('');
    }
}
function decodeUnicode(bytes) {
    try {
        return new TextDecoder('utf-16le').decode(bytes);
    }
    catch (_a) {
        var out = '';
        for (var i = 0; i + 1 < bytes.length; i += 2) {
            out += String.fromCharCode(bytes[i] | (bytes[i + 1] << 8));
        }
        return out;
    }
}
var NUL_CHAR = String.fromCharCode(0);
var CELL_MARK_CHAR = String.fromCharCode(7);
var LINE_BREAK_CHAR = String.fromCharCode(11);
var PAGE_BREAK_CHAR = String.fromCharCode(12);
var FIELD_CODE_CHARS = [19, 20, 21].map(function (code) { return String.fromCharCode(code); });
function cleanExtractedText(raw) {
    var text = raw.split(NUL_CHAR).join('');
    FIELD_CODE_CHARS.forEach(function (char) { text = text.split(char).join(''); });
    text = text.split(CELL_MARK_CHAR).join('\n');
    text = text.split('\r').join('\n');
    text = text.split(LINE_BREAK_CHAR).join('\n');
    text = text.split(PAGE_BREAK_CHAR).join('\n\n');
    text = text.replace(/[ \t]{2,}/g, ' ');
    text = text.replace(/\n{3,}/g, '\n\n');
    return text
        .split('\n')
        .map(function (line) { return line.trim(); })
        .join('\n')
        .trim();
}
export function extractLegacyDocText(arrayBuffer) {
    try {
        var ctx = parseCfb(arrayBuffer);
        var entries = ctx.entries;
        var wordDocumentEntry = findEntry(entries, 'WordDocument');
        if (!wordDocumentEntry)
            return '';
        var wordDocumentStream = readStream(ctx, wordDocumentEntry);
        var fibView = new DataView(wordDocumentStream.buffer, wordDocumentStream.byteOffset, wordDocumentStream.byteLength);
        if (fibView.getUint16(0, true) !== 0xa5ec)
            return '';
        var flags = fibView.getUint16(10, true);
        var useTable1 = (flags & 0x0200) !== 0;
        var tableEntry = findEntry(entries, useTable1 ? '1Table' : '0Table');
        if (!tableEntry)
            return '';
        var tableStream = readStream(ctx, tableEntry);
        var csw = fibView.getUint16(32, true);
        var fibRgW97End = 34 + csw * 2;
        var cslw = fibView.getUint16(fibRgW97End, true);
        var fibRgLw97End = fibRgW97End + 2 + cslw * 4;
        var cbRgFcLcb = fibView.getUint16(fibRgLw97End, true);
        var fibRgFcLcbStart = fibRgLw97End + 2;
        var clxPairIndex = 33;
        if (cbRgFcLcb <= clxPairIndex)
            return '';
        var clxPairOffset = fibRgFcLcbStart + clxPairIndex * 8;
        var fcClx = fibView.getUint32(clxPairOffset, true);
        var lcbClx = fibView.getUint32(clxPairOffset + 4, true);
        if (!lcbClx || fcClx + lcbClx > tableStream.length)
            return '';
        var clxView = new DataView(tableStream.buffer, tableStream.byteOffset + fcClx, lcbClx);
        var cursor = 0;
        var pcdtLcb = -1;
        var pcdtOffset = -1;
        while (cursor < clxView.byteLength) {
            var marker = clxView.getUint8(cursor);
            if (marker === 1) {
                var cbGrpprl = clxView.getUint16(cursor + 1, true);
                cursor += 1 + 2 + cbGrpprl;
            }
            else if (marker === 2) {
                pcdtLcb = clxView.getUint32(cursor + 1, true);
                pcdtOffset = cursor + 5;
                break;
            }
            else {
                break;
            }
        }
        if (pcdtOffset < 0 || pcdtLcb < 4)
            return '';
        var pieceCount = Math.floor((pcdtLcb - 4) / 12);
        if (pieceCount <= 0)
            return '';
        var cpArrayOffset = pcdtOffset;
        var pcdArrayOffset = cpArrayOffset + (pieceCount + 1) * 4;
        var textParts = [];
        for (var i = 0; i < pieceCount; i += 1) {
            var cpStart = clxView.getUint32(cpArrayOffset + i * 4, true);
            var cpEnd = clxView.getUint32(cpArrayOffset + (i + 1) * 4, true);
            var charCount = cpEnd - cpStart;
            if (charCount <= 0 || charCount > 5000000)
                continue;
            var pcdFc = clxView.getUint32(pcdArrayOffset + i * 8 + 2, true);
            var isAnsi = (pcdFc & 0x40000000) !== 0;
            var fc = isAnsi ? (pcdFc & 0x3fffffff) / 2 : (pcdFc & 0x3fffffff);
            var byteLength = isAnsi ? charCount : charCount * 2;
            if (fc + byteLength > wordDocumentStream.length)
                continue;
            var pieceBytes = wordDocumentStream.subarray(fc, fc + byteLength);
            textParts.push(isAnsi ? decodeAnsi(pieceBytes) : decodeUnicode(pieceBytes));
        }
        return cleanExtractedText(textParts.join(''));
    }
    catch (_a) {
        return '';
    }
}
